import React, { useEffect, useState } from "react"
import DropDownAction from "./DropDownAction"
import DataTable from "react-data-table-component"

import Application from "services/applications/Application.service"
import { max, wrap } from "lodash"

var appService = null
const BASE_URL = process.env.REACT_APP_BASE_URL

const Applications = props => {
  const [row_data, setrow_data] = useState()
  // for env audit
  var finalTorUrl = BASE_URL + "verify/tor/"

  // console.log(props.data)

  const fetchData = page => {
    props.paginate(page)
  }

  useEffect(() => {
    var rws = []
    let officer = ""

    appService = new Application(props.user)

    props.data.data.forEach(app => {
      var client = app.client.first_name + " " + app.client.last_name
      if (app.client.other_name != null) {
        client += " " + app.client.other_name
      }

      // For environmental Audit, we don't use the registered applicant's name
      // Instead, we pick either the company or organization info
      if (app.service_id == 17003) {

        // Final ToR Link
        finalTorUrl = finalTorUrl + app.app_id

        if (app.environmental_audit_request != null) {

          if (app.environmental_audit_request.applicant_name != null) {
            client = app.environmental_audit_request.applicant_name
          }

          if (app.environmental_audit_request.institution_name != null) {
            client = app.environmental_audit_request.institution_name
          }

          if (app.environmental_audit_request.company_id != null) {
            client = app.environmental_audit_request.company.name
          }
        }
      }

      let showReassign = false
      // if application status is under-review and showReassignStaffBtn
      if (app.application_status_id == 3 && props.showReassignStaffBtn) {
        showReassign = true
      }

      let officer = ""
      if (app.application_assignment != undefined) {
        officer =
          app.application_assignment.staff.first_name +
          " " +
          app.application_assignment.staff.last_name
      }

      var dgApproved = false

      if (app.decision === "DG APPROVED") {
        dgApproved = true
      }

      var alertType = "mt-2 alert alert-info"
      if (app.application_status.id === 6) {
        alertType = "mt-2 alert alert-success"
      } else if (app.application_status.id === 7) {
        alertType = "mt-2 alert alert-warning"
      } else if (app.application_status.id === 9) {
        alertType = "mt-2 alert alert-danger"
      } else {
        alertType = "mt-2 alert alert-info"
      }

      rws.push({
        app_id: "" + app.app_id + "",
        applicant: client,
        date_submitted: app.submitted_at,
        service: app.service.name,
        officer: officer,
        status: (
          <div className={alertType}>
            {app.application_status.name}
            <br></br>{" "}
            {app.resubmitted ? (
              <span className="badge bg-warning center">Re-submited</span>
            ) : (
              ""
            )}
          </div>
        ),
        actions: (
          <DropDownAction
            showToRCertificate={app.tor_approval_date != null? true : false}
            isDGReturned={props.isDGReturned ? true : false}
            assignStaff={props.assignStaff}
            viewOnly={props.viewOnly}
            hodSubmittedApps={props.hodSubmittedApps}
            user={props.user}
            appId={app.id}
            app_id={app.app_id}
            dgApproved={dgApproved}
            isManualApplication={props.isManualApplication ? true : false}
            showReassignStaffBtn={props.showReassignStaffBtn}
            showReassign={showReassign}
          />
        ),
      })
      setrow_data(rws)
    })

    if (props.data.data.length == 0) {
      setrow_data([])
    }
  }, [props.data])

  // Serverside pagination
  const columns = [
    {
      name: "ID",
      selector: row => row.app_id,
      wrap: true,
    },
    {
      name: "Type",
      selector: row => row.service,
      wrap: true,
    },
    {
      name: "Applicant",
      selector: row => row.applicant,
      wrap: true,
    },
    {
      name: "Date Submitted",
      selector: row => row.date_submitted,
    },
    {
      name: "Assigned Officer",
      selector: row => row.officer,
    },
    {
      name: "Application Status",
      selector: row => row.status,
      wrap: true,
      // length:max
    },
    {
      name: "Actions",
      selector: row => row.actions,
    },
  ]

  return (
    <DataTable
      columns={columns}
      data={row_data}
      highlightOnHover
      pagination
      paginationServer
      paginationTotalRows={props.data.total}
      paginationPerPage={props.data.per_page}
      paginationComponentOptions={{
        noRowsPerPage: true,
      }}
      onChangePage={page => fetchData(page)}
    />
  )
}

export default Applications
